import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Truck Only asset types.
 * Covers: TRUCK_ONLY, TRUCK_ONLY_25.
 *
 * Required fields: Driver License Number, Driver First Name, Driver Last Name,
 *                  Truck License Plate Number.
 * No Asset Size field is rendered for this form.
 */
const TruckOnlyForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange}) => {
  return (
    <>
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
        required
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default TruckOnlyForm;

